import { cn } from '@/lib/utils'

/** Dots-and-count progress strip shared by the day-close and shift-close wizards. */
export function StepIndicator<S extends string>({ step, order }: { step: S; order: readonly S[] }) {
  const stepNumber = order.indexOf(step) + 1
  const total = order.length
  return (
    <div className="flex items-center gap-1.5 pt-2" aria-label={`Step ${stepNumber} of ${total}`}>
      {order.map((_, i) => (
        <span
          key={i}
          className={cn(
            'h-2 rounded-full transition-all',
            i + 1 === stepNumber ? 'w-8 bg-foreground' : 'w-2 bg-muted',
            i + 1 < stepNumber && 'bg-emerald-500',
          )}
          aria-hidden="true"
        />
      ))}
      <span className="ml-2 text-sm text-muted-foreground">
        Step {stepNumber} of {total}
      </span>
    </div>
  )
}
